var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDownloadInvoice = function SvgDownloadInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18.065 22.023"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7b838f",
    "data-name": "Group 2763"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.065 2.79v16.437a2.948 2.948 0 0 1-3.08 2.8H3.08a2.948 2.948 0 0 1-3.08-2.8V7.768a2.235 2.235 0 0 1 .755-1.657L6.728.685a2.623 2.623 0 0 1 .47-.329A2.865 2.865 0 0 1 8.555 0h6.43a2.947 2.947 0 0 1 3.08 2.79M16.91 19.234V2.797a1.844 1.844 0 0 0-1.925-1.748h-6.43a1.517 1.517 0 0 0-.655.154 5.008 5.008 0 0 0-1.062 4.663c.208.629-.547 1.244-1.217 1.014-1.047-.489-4.451-.545-4.466.888v11.466a1.853 1.853 0 0 0 1.925 1.748h11.913a1.846 1.846 0 0 0 1.917-1.748M5.668 3.132 2.995 5.565a6.967 6.967 0 0 1 2.634.21 5.783 5.783 0 0 1 .039-2.643",
    "data-name": "Path 18695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.404 12.56a.611.611 0 0 1 .864.864l-2.4 2.4a.6.6 0 0 1-.855 0l-2.4-2.4a.611.611 0 0 1 .864-.864l1.352 1.344V7.843a.611.611 0 0 1 1.222 0v6.069Z",
    "data-name": "Path 18697"
  }))));
};
export default SvgDownloadInvoice;